import cx from 'classnames'
import type { DetailsHTMLAttributes, PropsWithChildren } from 'react'

import Badge from '@ui/Badge'
import Typography from '@ui/Typography'
import { ChevronDownIcon } from '@ui/icons/tint/20/general'

import * as styles from './Collapsible.css'

interface CollapsibleProps {
  title: string | React.FC
  actionText?: string
  rootClassName?: string
  headerClassName?: string
  contentClassName?: string
  open?: boolean
  onToggle?: DetailsHTMLAttributes<HTMLElement>['onToggle']
}

const Collapsible = ({
  title,
  actionText,
  children,
  rootClassName,
  headerClassName,
  contentClassName,
  open,
  onToggle,
}: PropsWithChildren<CollapsibleProps>) => {
  const TitleComponent =
    typeof title === 'string'
      ? () => (
          // @ts-expect-error Provide Typography with a component prop
          <Typography variant="callout" color="textPrimary">
            {title}
          </Typography>
        )
      : title

  return (
    <details className={cx(styles.root, rootClassName)} open={open} onToggle={onToggle}>
      <summary className={cx(styles.header, headerClassName)}>
        <div className={styles.headerLeftColumn}>
          <TitleComponent />
        </div>
        <div className={styles.headerRightColumn}>
          {actionText && (
            <Badge label={actionText} color="primary" className={styles.badge} />
          )}
          <ChevronDownIcon className={styles.chevron} />
        </div>
      </summary>
      <div className={cx(styles.content, contentClassName)}>{children}</div>
    </details>
  )
}

export default Collapsible
